import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;

export function VideoPlayerIframe({iframeRef, src}: {iframeRef: RefObject<HTMLIFrameElement>, src?: string}){
    return (
        <div className="player">
            <div className="dark-overlay" />
            <div className="main-player bordered">
                <iframe width="100%" height="auto" style={{aspectRatio: '16/9'}} frameborder="0" scrolling="no" allowfullscreen="" allow="autoplay *; fullscreen *" ref={iframeRef} src={src}/>
            </div>
        </div>
    )
}